import React from 'react';
import { NavLink } from 'react-router-dom';

const NavigationBar = () => (
  <footer>
    <ul className="NavigationBar">
      <li>
        <NavLink to="/reports" activeClassName="is-active">
          <img
            src="/images/icons/tabicons/blue/meldungen.png"
            alt="Meldungen"
            className="tabicon"
          />
          <img
            src="/images/icons/tabicons/red/meldungen.png"
            alt="Meldungen"
            className="tabicon tabicon--active"
          />
          Meldungen
        </NavLink>
      </li>
      <li>
        <NavLink to="/katastrophen" activeClassName="is-active">
          <img
            src="/images/icons/tabicons/blue/katastrophen.png"
            alt="Katastrophen"
            className="tabicon"
          />
          <img
            src="/images/icons/tabicons/red/katastrophen.png"
            alt="Katastrophen"
            className="tabicon tabicon--active"
          />
          Katastrophen
        </NavLink>
      </li>
      <li>
        <NavLink to="/orte" activeClassName="is-active">
          <img src="/images/icons/tabicons/blue/orte.png" alt="Meine Orte" className="tabicon" />
          <img
            src="/images/icons/tabicons/red/orte.png"
            alt="Meine Orte"
            className="tabicon tabicon--active"
          />
          Meine Orte
        </NavLink>
      </li>
      <li>
        <NavLink to="/notruf" activeClassName="is-active">
          <img src="/images/icons/tabicons/blue/notruf.png" alt="Notruf" className="tabicon" />
          <img
            src="/images/icons/tabicons/red/notruf.png"
            alt="Notruf"
            className="tabicon tabicon--active"
          />
          Notruf
        </NavLink>
      </li>
      <li>
        <NavLink to="/informationen" activeClassName="is-active">
          <img src="/images/icons/tabicons/blue/info.png" alt="Information" className="tabicon" />
          <img
            src="/images/icons/tabicons/red/info.png"
            alt="Information"
            className="tabicon tabicon--active"
          />
          Information
        </NavLink>
      </li>
    </ul>
  </footer>
);

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/js/components/NavigationBar.js